import React from 'react';
import PropTypes from 'prop-types';
import { palette } from '../../constants/styles';
import Text from './Text';
import Icon from './Icon';

const NumberTip = ({
  msg1, msg2, onClick, arg1, arg2, minusAvailable, plusAvailable,
}) => (
  <Text type="genericMessage" style={{ lineHeight: '2', marginTop: '0' }} medium>
    {msg1}
    <Icon icon="minusIcon" color={(minusAvailable) ? palette.finautaOrange : palette.basicGray} size={25} style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer', marginBottom: '-7px' }} onClick={() => { onClick(arg1); }} />
    {'y '}
    <Icon icon="plusIcon" color={(plusAvailable) ? palette.secondaryColor : palette.basicGray} size={25} style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer', marginBottom: '-7px' }} onClick={() => { onClick(arg2); }} />
    {msg2}
  </Text>
);

NumberTip.propTypes = {
  msg1: PropTypes.string,
  msg2: PropTypes.string,
  onClick: PropTypes.func,
  arg1: PropTypes.number,
  arg2: PropTypes.number,
  minusAvailable: PropTypes.bool,
  plusAvailable: PropTypes.bool,
};

NumberTip.defaultProps = {
  msg1: '',
  msg2: '',
  arg1: 0,
  arg2: 0,
  minusAvailable: null,
  plusAvailable: null,
  onClick: () => {},
};

export default NumberTip;
